import React, { Component, PropTypes } from 'react';

import './Heading.css';

export default class Heading extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
    }

    render() {
        return (
            <div className="heading">
                <h1>{this.props.title}</h1>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/Heading.jsx